import { DetailedHTMLProps, FC, ForwardedRef, HTMLAttributes, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface CardBodyProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    ref?: ForwardedRef<HTMLDivElement>;
}
const CardBody = forwardRef<HTMLDivElement, CardBodyProps>((props, ref) => {
    const { children, className, ...rest } = props;

    return (
        <div {...rest} ref={ref} className={twMerge('px-5 py-4', className)}>
            {children}
        </div>
    );
});

export default CardBody;
